import React, { useState } from "react";
import "./Nav.css";
import { IoHome } from "react-icons/io5";
import { MdQuickreply } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { AiFillProject } from "react-icons/ai";
import { GoCircuitBoard } from "react-icons/go";
import { motion } from "framer-motion";

// import { a } from "react-scroll";
const Nav = () => {
  const [state, setState] = useState('home');
  return (
    <motion.nav initial={{opacity:0, bottom:'-5%'}} animate={{
      opacity:1,
      bottom:'2%'
    }}
    transition={{duration:1}}>
      <a to="home" href="#home" onClick={() => setState("home")}>
        <abbr title="Home" className={state === "home" ? "active" :'no'}>
          <IoHome />
        </abbr>
      </a>
      <a to="about" href="#about" onClick={() => setState("about")}>
        {" "}
        <abbr title="About" className={state === "about" ? "active" :'no'}>
          <FaUser />
        </abbr>
      </a>
      <a href="#skills" aria-label="skills" onClick={() => setState("skills")}>
        <abbr title="Skills" className={state === "skills" ? "active" :'no'}>
          <GoCircuitBoard />{" "}
        </abbr>
      </a>
      <a href="#projects" onClick={() => setState("projects")}>
        {" "}
        <abbr title="Projects" className={state === "projects" ? "active" :'no'}>
          <AiFillProject />
        </abbr>
      </a>
      <a href="#contact" to="contact" onClick={() => setState("contact")}>
        {" "}
        <abbr title="Contact" className={state === "contact" ? "active" :'no'}>
          <MdQuickreply />
        </abbr>
      </a>
    </motion.nav>
  );
};

export default Nav;
